// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2yQ5x","row":"Node_row__gXxCA","label":"Node_label__2SaIW","footer":"Node_footer__31FlF"};